import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Smartphone, Package, ThumbsUp } from "lucide-react";

const steps = [
  {
    icon: Smartphone,
    title: "Verify Your Device",
    description: "Ensure you're using an Android device in the United States to qualify for this exclusive offer."
  },
  {
    icon: Package,
    title: "Claim Your Samples",
    description: "Complete a simple verification process to confirm your eligibility and shipping details."
  },
  {
    icon: ThumbsUp,
    title: "Enjoy Buffalo Wild Wings",
    description: "Receive your samples and experience the bold, signature flavors of Buffalo Wild Wings at home."
  }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
              How It Works
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Getting your free Buffalo Wild Wings samples is quick and easy. Just follow these simple steps.
            </p>
          </motion.div>
        </div>
        
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {steps.map((step, index) => (
            <motion.div key={index} variants={item}>
              <Card className="bg-card border-border h-full hover:shadow-md transition-shadow">
                <CardContent className="pt-6 flex flex-col items-center text-center">
                  <div className="mb-5 bg-primary/10 p-4 rounded-full">
                    <step.icon size={32} className="text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-card-foreground">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {step.description}
                  </p>
                  <div className="mt-4 flex items-center justify-center">
                    <div className="h-8 w-8 rounded-full bg-secondary flex items-center justify-center text-secondary-foreground font-bold">
                      {index + 1}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-16 bg-muted rounded-xl p-6 md:p-8 text-center"
        >
          <p className="text-lg text-muted-foreground">
            <span className="font-semibold">Important:</span> This offer is exclusively available for Android users in the United States. Limited quantities available, so claim yours today!
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;